/**
 * Holds the coupon preview details from the new preview.json endpoint (PPIWEBM-2951).
 * The payload is built and fetched server-side at page render and injected into serverData
 * (`couponPreview`), so this module only hydrates from it — no client XHR. Consumption /
 * rendering is handled separately (PPIWEBM-2952); the manual-coupon re-fetch is a later ticket.
 *
 * Shape: { items: [{ couponInformation, eligiblePlans, ineligiblePlans }], success }.
 */
export default {
    namespaced: true,

    state: {
        items: [],
        success: false,
    },

    mutations: {
        setCouponPreview(state, payload) {
            state.items = payload?.items ?? [];
            state.success = payload?.success === true;
        },
    },

    actions: {
        loadServerData({ commit, rootGetters }) {
            const couponPreview = rootGetters.getServerDataByKey('couponPreview');

            if (couponPreview) {
                commit('setCouponPreview', couponPreview);
            }
        },
    },

    getters: {
        getCouponPreviewItems: (state) => state.items,
    },
};
